<template>
  <div class="fileupload">
    <!-- <uploader
      :options="options"
      :autoStart="false"
      ref="uploader"
      :file-status-text="statusText"
      @files-added="onFileAdded"
      @file-success="onFileSuccess"
      class="uploader-example"
    >
      <uploader-unsupport></uploader-unsupport>
      <uploader-drop>
        <p>拖拽文件至此或点击按钮</p>
        <uploader-btn>选择文件</uploader-btn>
      </uploader-drop>
      <div>
        <uploader-list></uploader-list>
      </div>
    </uploader>-->
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <i class="el-icon-folder-checked"></i>
            <span>作品相关文件</span>
          </div>
          <div
            class="text item"
            v-for="(item, index) in completeArray"
            :key="index"
          >
            <div>
              <el-row>
                <el-col :span="8">
                  <img
                    :src="item.path"
                    v-if="attrs[0].indexOf(item.type) != -1"
                    style="width: 100px; height: 50px"
                  />
                  <i
                    class="el-icon-document"
                    v-if="
                      attrs[2].indexOf(
                        item.fileName.substring(
                          item.fileName.lastIndexOf('.'),
                          item.fileName.length
                        )
                      ) != -1
                    "
                    style="font-size: 50px"
                  ></i>
                </el-col>
                <el-col
                  :span="12"
                  v-if="
                    attrs[2].indexOf(
                      item.fileName.substring(
                        item.fileName.lastIndexOf('.'),
                        item.fileName.length
                      )
                    ) != -1
                  "
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.fileName"
                    placement="top-start"
                  >
                    <span>{{ item.fileName }}</span>
                  </el-tooltip>
                </el-col>
                <el-col
                  :span="12"
                  v-if="
                    attrs[0].indexOf(
                      item.fileName.substring(
                        item.fileName.lastIndexOf('.'),
                        item.fileName.length
                      )
                    ) != -1
                  "
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.fileName"
                    placement="top-start"
                  >
                    <span>{{ item.fileName }}</span>
                  </el-tooltip>
                </el-col>
                <el-col
                  :span="12"
                  v-if="
                    attrs[1].indexOf(
                      item.fileName.substring(
                        item.fileName.lastIndexOf('.'),
                        item.fileName.length
                      )
                    ) != -1
                  "
                >
                  <span>{{ item.fileName }}</span>
                  <video-player
                    class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"

                    :options="{
                      playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                      autoplay: false, //如果true,浏览器准备好时开始回放。
                      muted: false, // 默认情况下将会消除任何音频。
                      loop: false, // 导致视频一结束就重新开始。
                      preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                      language: 'zh-CN',
                      aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如&quot;16:9&quot;或&quot;4:3&quot;）
                      fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                      sources: [
                        {
                          type:
                            'video/mp4' ||
                            'video/x-flv' ||
                            'video/webm' ||
                            'video/ogg',
                          src: item.path, //url地址
                          // src: &quot;&quot; //url地址
                        },
                      ],
                      poster: '', //你的封面地址
                      // width: document.documentElement.clientWidth,
                      notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                      controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true, //全屏按钮
                      },
                    }"
                  ></video-player>
                </el-col>
                <el-col :span="2">
                  <i
                    class="el-icon-download"
                    style="cursor: pointer"
                    @click="download(item.path)"
                    v-if="
                      attrs[1].indexOf(
                        item.fileName.substring(
                          item.fileName.lastIndexOf('.'),
                          item.fileName.length
                        )
                      ) == -1
                    "
                  ></i>
                  <!-- <i
                    class="el-icon-video-play"
                    style="cursor: pointer"
                    @click="download(item.path)"
                    v-if="attrs[1].indexOf(item.fileName.substring(item.fileName.lastIndexOf('.'), item.fileName.length)) != -1"
                  ></i> -->
                </el-col>
                <!-- <el-col :span="2">
                  <i
                    class="el-icon-delete"
                    style="cursor: pointer"
                    @click="deleteFile(item.businessCode,item.fileName,1)"
                  ></i>
                </el-col>-->
              </el-row>
            </div>
          </div>
        </el-card>
      </el-col>
      <!-- <el-col :span="12">
        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <i class="el-icon-files"></i>
            <span>未完成上传列表</span>
          </div>
          <div class="text item" v-for="(item,index) in unCompleteArray" :key="index">
            <div>
              <el-row>
                <el-col :span="10">
                  <i class="el-icon-document" style="font-size: 50px"></i>
                </el-col>
                <el-col :span="12">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.fileName"
                    placement="top-start"
                    v-if="item.fileName.length>11"
                  >
                    <span>{{item.fileName.slice(0,15)}}...{{item.fileName.split(".")[item.fileName.split(".").length-1]}}(已上传{{Math.floor(item.schedule*10000)/100}}%)</span>
                  </el-tooltip>
                  <span
                    v-if="item.fileName.replace(item.businessCode+'-','').length<=11"
                  >{{item.fileName}}(已上传{{Math.floor(item.schedule*10000)/100}}%)</span>
                </el-col>
                <el-col :span="2">
                  <i
                    class="el-icon-delete"
                    style="cursor: pointer"
                    @click="deleteFile(item.hash,item.fileName,2)"></i>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </el-col>-->
    </el-row>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import { getFileList, deleteFiles } from '@/api/system/index'

export default {
  name: 'fileComponent',
  props: [
    'verifyTypeArray',
    'maxSize',
    'businessCodeArray',
    'remark',
    'completeArray'
  ], // verifyTypeArray（可选）：需要过滤的文件类型，即此文件类型的文件不上传，maxSize：文件最大上传大小,businessCodeArray：回显的MD5列表，用于回显数据
  data () {
    return {
      currentUploadMd5: [],
      timer: '',
      options: {
        target:
          this.systemURL + '/actuator/fileUpload/fileUpload/' + this.remark,
        chunkSize: 5 * 1024 * 1024, // 上传文件分块大小
        fileParameterName: 'file', // 上传文件时文件的参数名，默认file
        simultaneousUploads: 5, // 并发上传数量，默认3
        maxChunkRetries: 3, // 最大自动失败重试上传次数
        testChunks: true, // 是否开启服务器分片校验
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          if (message) {
            let objMessage = JSON.parse(message)
            return (
              (objMessage.uploadedChunks || []).indexOf(chunk.offset + 1) >= 0
            )
          } else {
            // 没有返回json数据表示没有发送上传分片的请求，该文件已经上传过了，不予上传
            return true
          }
        }
      },
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4' || 'video/x-flv' || 'video/webm' || 'video/ogg',
            src: '' // url地址
            // src: "" //url地址
          }
        ],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      autoStart: false,
      statusText: {
        success: '成功了',
        error: '出错了',
        uploading: '上传中',
        paused: '暂停中',
        waiting: '等待中'
      },
      attrs: [
        ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv', '.avi'],
        [
          '.doc',
          '.docx',
          '.xls',
          '.xlsx',
          '.ppt',
          '.pptx',
          '.pdf',
          '.txt',
          '.tif',
          '.tiff'
        ]
      ],
      unCompleteArray: [],
      localFileArry: [],
      fileList: [],
      hashAry: []
    }
  },
  computed: {
    // Uploader实例
    uploader () {
      return this.$refs.uploader.uploader
    }
  },
  mounted () {
    /* this.getFileList(); */
    /* this.timer = setInterval(this.timerGetFileList, 5000); */
  },
  // 清除定时器
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  destroyed () {
    window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    window.removeEventListener('unload', (e) => this.exit(e))
  },
  methods: {
    beforeunloadFn (e) {
      deleteFiles(this.systemURL, this.hashAry)
      this.beforeUnloadTime = new Date().getTime()
    },
    deleteFile (md5, fileName, type) {
      deleteFiles(this.systemURL, [
        {
          hash: md5,
          remark: this.remark,
          fileName: fileName
        }
      ])
      // 移除上传列表
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].uniqueIdentifier === md5) {
          this.uploader.removeFile(this.fileList[i])
          break
        }
      }
      if (type === 1) {
        for (let i = 0; i < this.completeArray.length; i++) {
          if (this.completeArray[i].businessCode === md5) {
            this.completeArray.splice(i, 1)
            break
          }
        }
      } else {
        for (let i = 0; i < this.unCompleteArray.length; i++) {
          if (this.unCompleteArray[i].businessCode === md5) {
            this.unCompleteArray.splice(i, 1)
            break
          }
        }
      }
    },
    download (path) {
      window.open(path)
    },
    // 文件上传成功回调
    onFileSuccess (rootFile, file, response, chunk) {
      this.currentUploadMd5.push(chunk.file.uniqueIdentifier)
    },
    timerGetFileList () {
      if (this.currentUploadMd5.length > 0) {
        this.currentUploadMd5.forEach((item) => {
          this.getOneFileList(item)
        })
      }
    },
    getFileList () {
      let url = this.systemURL
      // if (this.businessCodeArray) {
      getFileList(url, this.remark).then((res) => {
        this.completeArray = res.data.completeArray
        this.unCompleteArray = res.data.unCompleteArray
      })
      // }
    },
    // 移除所有文件，提交表单时可以调用此方法
    removeFileList () {
      this.fileList.forEach((file) => {
        this.uploader.removeFile(file)
      })
    },
    // 添加文件时的校验
    onFileAdded (files, fileList) {
      this.fileList = fileList
      fileList.forEach((file) => {
        if (this.verifyTypeArray) {
          this.verifyTypeArray.forEach((item) => {
            if (item === file.getType()) {
              // 移除不符合指定文件类型的文件
              this.uploader.removeFile(file)
              return
            }
          })
          // 移除超过上传大小的文件
          if (file.size > this.maxSize) {
            this.uploader.removeFile(file)
            return
          }
          this.computeMD5(file, fileList.length)
        } else {
          this.computeMD5(file, fileList.length)
        }
      })
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5 (file, length) {
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = this.options.chunkSize
      let chunks = Math.ceil(file.size / chunkSize)
      let spark = new SparkMD5.ArrayBuffer()
      // 文件状态设为"计算MD5"
      this.statusText.paused = '计算MD5中'
      // 上传文件暂停
      file.pause()
      loadNext()
      fileReader.onload = (e) => {
        spark.append(e.target.result)
        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            this.statusText.paused =
              '校验MD5 ' + ((currentChunk / chunks) * 100).toFixed(0) + '%'
          })
        } else {
          let md5 = spark.end()
          this.$emit('getMd5', md5, file.name, length) // @getMd5="function"
          this.hashAry.push({
            hash: md5,
            fileName: file.name
          })
          let hashStrAry = []
          this.completeArray.forEach((hash) => {
            hashStrAry.push(hash.businessCode)
          })
          this.unCompleteArray.forEach((hash) => {
            hashStrAry.push(hash.businessCode)
          })
          this.hashAry.forEach((hash) => {
            hashStrAry.push(hash.hash)
          })
          this.businessCodeArray.forEach((hash) => {
            hashStrAry.push(hash)
          })
          var result = []
          hashStrAry.forEach(function (item) {
            if (
              hashStrAry.indexOf(item) !== hashStrAry.lastIndexOf(item) &&
              result.indexOf(item) === -1
            )
              result.push(item)
          })
          console.log(this.completeArray)
          console.log(this.unCompleteArray)
          if (result.includes(md5)) {
            this.$message('文件不能重复上传')
            this.uploader.removeFile(file)
          } else {
            this.computeMD5Success(md5, file)
            this.statusText.paused = '暂停中'
            /*
                          console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
              */
          }
        }
      }
      fileReader.onerror = function () {
        this.error(`文件${file.name}读取出错，请检查该文件`)
        file.cancel()
      }

      function loadNext () {
        let start = currentChunk * chunkSize
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },
    computeMD5Success (md5, file) {
      // 将自定义参数直接加载uploader实例的opts上
      Object.assign(this.uploader.opts, {
        query: {
          ...this.params
        }
      })
      file.uniqueIdentifier = md5
      // 继续上传文件
      file.resume()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/fileComponentList.vue